<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="退款申请详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="refundApplyNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate :current="detailInfo" @success="init" :show="['WAIT'].includes(detailInfo.approvalStatus)" />
      </div>
      <div class="main-cont" v-loading="loading">
        <div class="main-cont-item">
          <h2 class="title-text">
            基础信息
            <icon-status
              :color="statusColorFilters(detailInfo.approvalStatus)"
              :status="detailInfo.approvalStatusDesc"
            />
          </h2>
          <el-row :gutter="20" style="margin-top: -8px;">
            <jr-col :data-show="firstCol" :data="detailInfo" />
            <jr-col :data-show="secondCol" :data="detailInfo" />
            <jr-col :data-show="thirdCol" :data="detailInfo" />
          </el-row>
          <el-row>
            <data-show label="退款原因:">
              <div>{{detailInfo.refundReason || '-'}}</div>
            </data-show>
          </el-row>
          <el-row v-if="['REJECT'].includes(detailInfo.approvalStatus)">
            <data-show label="驳回原因:">
              <div>{{detailInfo.rejectReason || '-'}}</div>
            </data-show>
          </el-row>
        </div>
        <div class="main-cont-item" v-if="detailInfo.refundInfos && detailInfo.refundInfos.length">
          <h2 class="title-text">拟退款方案</h2>
          <info-tree :list="detailInfo.refundInfos" :amount="detailInfo.refundAmount" />
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">原交易单信息</h2>
          <jr-table
            :size="formSize"
            :tableData="infoList"
            :tableColumn="tableColumn"
          />
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">退款记录</h2>
          <jr-table
            :size="formSize"
            :tableData="detailInfo.refundRecords"
            :tableColumn="refundTableColumn"
          />
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { getApplyDetail } from '@/api/refund';
import btnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';
import infoTree from './info-tree';

export default {
  props: {
    refundApplyNo: {
      type: String,
      default: '',
    },
  },
  components: { btnsOperate, infoTree },
  data() {
    return {
      detailInfo: {},
      loading: false,
      // 基础信息
      firstCol: [
        { label: '退款申请编号:', prop: 'refundApplyNo' },
        { label: '原交易单号:', prop: 'origTransNum' },
        { label: '客户编号:', prop: 'businessNo' },
        { label: '客户名称:', prop: 'businessName' },
      ],
      secondCol: [
        { label: '申请退款金额:', prop: 'refundAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单已退总额:', prop: 'refundedAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单实收金额:', prop: 'realAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单应收金额:', prop: 'shouldAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      thirdCol: [
        { label: '申请时间:', prop: 'createTime', filters: 'formatTime' },
        { label: '申请人:', prop: 'createUser' },
        { label: '操作时间:', prop: 'modifyTime', filters: 'formatTime' },
        { label: '操作人:', prop: 'modifyUser' },
      ],
      tableColumn: [
        { label: '交易单类型', prop: 'origTransTypeDesc' },
        { label: '交易单号', prop: 'origTransNum' },
        { label: '应收金额(元)', prop: 'shouldAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '实收金额(元)', prop: 'realAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '已退总额(元)', prop: 'refundedAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '已分账总额(元)', prop: 'dividedAmount', filterName: 'toFenThousandsAndFloat' },
      ],
      refundTableColumn: [
        { label: '退款单编号', prop: 'refundOrderNo' },
        { label: '创建时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '退款方式', prop: 'refundWayDesc' },
        { label: '退款渠道', prop: 'refundChannelDesc' },
        { label: '退款金额(元)', prop: 'refundAmount', filterName: 'toFenThousandsAndFloat' },
        {
          label: '状态',
          status: 'refundStatus',
          statusDesc: 'refundStatusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
        { label: '完成时间', prop: 'thirdFinishTime', filterName: 'formatTime' },
      ],
      infoList: [],
    };
  },
  watch: {
    refundApplyNo: {
      deep: true,
      handler() {
        if (this.refundApplyNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.infoList = [];
        this.init();
      });
    },
    init() {
      this.getApplyDetail();
    },
    statusColorFilters(status) {
      return setStatusColor(status, 'approvalStatus');
    },
    // 获取详情接口
    async getApplyDetail() {
      try {
        this.loading = true;
        const res = await getApplyDetail({ refundApplyNo: this.refundApplyNo });
        const { data = {} } = res;
        this.detailInfo = data || {};
        this.infoList = [
          {
            origTransType: data.origTransType || '',
            origTransTypeDesc: data.origTransTypeDesc || '',
            origTransNum: data.origTransNum || '',
            dividedAmount: data.dividedAmount ?? '',
            shouldAmount: data.shouldAmount ?? '',
            realAmount: data.realAmount ?? '',
            refundedAmount: data.refundedAmount ?? '',
          },
        ];
      } catch (error) {
        console.log(error);
        this.detailInfo = {};
        this.infoList = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

